/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PickDto } from '../../models/pick-dto';

export interface PickControllerDelete$Params {
  id: string;
}

export function pickControllerDelete(http: HttpClient, rootUrl: string, params: PickControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
  const rb = new RequestBuilder(rootUrl, pickControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PickDto>;
    })
  );
}

pickControllerDelete.PATH = '/api/picks/{id}';
